import { render, staticRenderFns } from "./integral_list.vue?vue&type=template&id=14d64142&scoped=true&"
import script from "./integral_list.vue?vue&type=script&lang=js&"
export * from "./integral_list.vue?vue&type=script&lang=js&"
import style0 from "./integral_list.vue?vue&type=style&index=0&id=14d64142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d64142",
  null
  
)

export default component.exports